module.exports = __webpack_public_path__ + "static/media/german_strongpoint_120.0a77885e.png";